import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { store } from '../store/store';
import Logger from '../common/logger';
import { issueReportArchiveApi } from '../api/issueReport/issueReportArchiveApiSlice';
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from '../action/snackbarCommands';

export const useArchiveIssueReport = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return async (id: string): Promise<boolean> => {
        try {
            await store.dispatch(issueReportArchiveApi.endpoints.archiveIssueReport.initiate({ id })).unwrap();
            dispatch(enqueueSuccessSnackbar({ message: t('issue_reports.archive.snackbar.archive_success') }));
            return true;
        } catch (error) {
            Logger('archiveIssueReport').error(error);
            dispatch(enqueueErrorSnackbar({ message: t('issue_reports.archive.snackbar.archive_error') }));
            return false;
        }
    };
};

export const useRestoreIssueReport = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return async (id: string): Promise<boolean> => {
        try {
            await store.dispatch(issueReportArchiveApi.endpoints.restoreIssueReport.initiate({ id })).unwrap();
            dispatch(enqueueSuccessSnackbar({ message: t('issue_reports.archive.snackbar.restore_success') }));
            return true;
        } catch (error) {
            Logger('restoreIssueReport').error(error);
            dispatch(enqueueErrorSnackbar({ message: t('issue_reports.archive.snackbar.restore_error') }));
            return false;
        }
    };
};
